"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableProgramFamiliesPerBusinessUnit = exports.ProgramFamily = void 0;
var businessUnits_1 = require("./businessUnits");
var ProgramFamily;
(function (ProgramFamily) {
    /**
     * Fernstudium
     */
    ProgramFamily["FS"] = "FS";
    /**
     * Online International
     */
    ProgramFamily["OI"] = "OI";
    /**
     * Orientierungsstudium
     */
    ProgramFamily["OS"] = "OS";
    /**
     * Mature Markets
     */
    ProgramFamily["EU"] = "EU";
    /**
     * Kombistudium (KS)
     */
    ProgramFamily["BS"] = "BS";
    /**
     * Mein Studium (MSD)
     */
    ProgramFamily["MS"] = "MS";
    /**
     * My Studies
     */
    ProgramFamily["MSE"] = "MSE";
    /**
     * LIBF (Dual Degree)
     */
    ProgramFamily["LI"] = "LI";
    /**
     * Campus Studies
     */
    ProgramFamily["CS"] = "CS";
    /**
     * Arbeitssuchende/Bildungsgutschein
     */
    ProgramFamily["ALO"] = "ALO";
    /**
     * Business to Business
     */
    ProgramFamily["B2B"] = "B2B";
    /**
     * Business to Customer
     */
    ProgramFamily["B2C"] = "B2C";
    /**
     * Duales Studium
     */
    ProgramFamily["DS"] = "DS";
    /**
     * Virtueller Campus
     */
    ProgramFamily["VC"] = "VC";
    /**
     * Virtuelles Fernstudium
     */
    ProgramFamily["VFS"] = "VFS";
    /**
     * Quarterly Intake
     */
    ProgramFamily["QS"] = "QS";
    /**
     * London Institute for Banking & Finance
     */
    ProgramFamily["LIBF"] = "LIBF";
    /**
     * University of Fredericton
     */
    ProgramFamily["UFRED"] = "UFRED";
    /**
     * @deprecated Duales Mein Studium (DMSD)
     * Please use `ProgramFamily.DMSD`  instead.
     */
    ProgramFamily["DMS"] = "DMSD";
    /**
     * Duales Mein Studium (DMSD)
     */
    ProgramFamily["DMSD"] = "DMSD";
    /**
     * Studierendenkolleg (Pathway)
     */
    ProgramFamily["SK"] = "SK";
    /**
     * Deine Weiterbildung
     */
    ProgramFamily["DWB"] = "DWB";
})(ProgramFamily || (exports.ProgramFamily = ProgramFamily = {}));
exports.availableProgramFamiliesPerBusinessUnit = (_a = {},
    _a[businessUnits_1.BusinessUnit.FS] = [
        ProgramFamily.FS,
        ProgramFamily.OI,
        ProgramFamily.OS,
        ProgramFamily.EU,
        ProgramFamily.BS,
        ProgramFamily.MS,
        ProgramFamily.MSE,
        ProgramFamily.LI,
        ProgramFamily.DMSD,
    ],
    _a[businessUnits_1.BusinessUnit.CS] = [ProgramFamily.CS, ProgramFamily.SK],
    _a[businessUnits_1.BusinessUnit.UPS] = [
        ProgramFamily.ALO,
        ProgramFamily.B2B,
        ProgramFamily.B2C,
        ProgramFamily.DWB,
    ],
    _a[businessUnits_1.BusinessUnit.DS] = [
        ProgramFamily.DS,
        ProgramFamily.VC,
        ProgramFamily.VFS,
        ProgramFamily.QS,
    ],
    _a[businessUnits_1.BusinessUnit.LIBF] = [ProgramFamily.LIBF],
    _a[businessUnits_1.BusinessUnit.UFRED] = [ProgramFamily.UFRED],
    _a);
